export function parseRoomInvitation(search: string): string | null {
  const values = new URLSearchParams(search).getAll('room');
  if (values.length !== 1 || !/^[a-z0-9]{4,6}$/i.test(values[0])) return null;
  return values[0].toUpperCase();
}
export function buildRoomInvitation(code: string, origin: string = window.location.origin): string {
  if (!/^[a-z0-9]{4,6}$/i.test(code)) throw new Error('Invalid room code');
  return `${origin.replace(/\/$/, '')}/?room=${encodeURIComponent(code.toUpperCase())}`;
}
